<template>
  <main class="main page-inside payment-result-page">
    <div class="section payment-section">
      <div class="page-inside-top">
        <div class="wrapper">
          <div class="title big">
            {{ $t('Your payment is being processed. Please wait...') }}
          </div>
          <div class="processing-spinner">
            <svg width="50" height="50" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" stroke="#007bff" stroke-width="4" fill="none" stroke-linecap="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '../axios';

export default {
  name: 'PaymentProcessingPage',
  data() {
    return {
      polling: null,
      orderId: null,
    };
  },
  mounted() {
    this.orderId = this.$route.query.order_id;
    this.startPolling();
  },
  beforeUnmount() {
    if (this.polling) clearInterval(this.polling);
  },
  methods: {
    startPolling() {
      this.polling = setInterval(this.checkStatus, 3000);
    },
    async checkStatus() {
      if (!this.orderId) return;
      try {
        const res = await axios.get(`orders/status`, { params: { order_id: this.orderId } });
        if (res.data) {
          if (res.data.status === 'ERROR') {
            clearInterval(this.polling);
            const errorMsg = encodeURIComponent(res.data.message || 'Unknown error');
            window.location.href = `/fail-payment?error=${errorMsg}`;
            return;
          }
          if (res.data.order) {
            const status = res.data.order.status;
            if (res.data.order.redirect_url) {
              clearInterval(this.polling);
              window.location.href = res.data.order.redirect_url;
              return;
            }
            // Numeric status handling
            switch (status) {
              case 2: // ORDER_AS_ACCEPTED
                clearInterval(this.polling);
                window.location.href = '/success-payment';
                return;
              case 3: // ORDER_AS_COMPLETED
                clearInterval(this.polling);
                window.location.href = '/success-payment';
                return;
              case 4: // ORDER_AS_DENIED
                clearInterval(this.polling);
                window.location.href = '/fail-payment?error=Payment+denied';
                return;
              case 5: // ORDER_AS_DELETED
                clearInterval(this.polling);
                window.location.href = '/fail-payment?error=Order+deleted';
                return;
              case 6: // ORDER_AS_CLIENT_REFUSED
                clearInterval(this.polling);
                window.location.href = '/fail-payment?error=Client+refused';
                return;
              case 7: // ORDER_PAYMENT_ERROR
                clearInterval(this.polling);
                window.location.href = '/fail-payment?error=Payment+error';
                return;
            }
          }
        }
      } catch (e) {
        clearInterval(this.polling);
        window.location.href = `/fail-payment?error=Network+error`;
      }
    }
  }
};
</script>

<style scoped>
.processing-spinner {
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  100% { transform: rotate(360deg); }
}
</style>
